import { useQuery, useQueryClient } from '@tanstack/react-query'
import { oauth2DashboardApi } from '../api/oauth2DashboardApi'
import type { OAuth2Config } from '../types/oauth2Dashboard'

export default function useOAuthConfigQuery() {
  const queryClient = useQueryClient()
  const queryKey = ['oauth2-config']

  const query = useQuery<OAuth2Config>({
    queryKey,
    queryFn: oauth2DashboardApi.getConfig,
  })

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey })
  }

  return { ...query, invalidate }
}
